module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Suits_S8.7de8a94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Suits_S8.jpg
// module id = 783J
// module chunks = 0